import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import { FeatureActionType, FeatureKeyType } from "../../api/generated"
import FeatureBlockContainer from "../block/FeatureBlockContainer"
import FeaturePermissionsHomeScreenForm from "../form/FeaturePermissionsHomeScreenForm"

const ManageHomeScreenFeaturePermissions = ({ card }: any) => {
  return (
    <Card card={card} title="Home" noaction emphasis="secondary">
      <CardBlock paddingTop={false}>
        <FeatureBlockContainer
          featureKey={FeatureKeyType.HomeScreenUnified}
          featureAction={FeatureActionType.HomeScreenView}
          context={null}
          to={null}
        />
        <FeaturePermissionsHomeScreenForm />
      </CardBlock>
    </Card>
  )
}

export default ManageHomeScreenFeaturePermissions
